import { render, staticRenderFns } from "./ContasPagarAtrasadas.vue?vue&type=template&id=33e6cece&"
import script from "./contasPagarAtrasadas.js?vue&type=script&lang=js&"
export * from "./contasPagarAtrasadas.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports